var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCareLineModal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 164,
    viewBox: "0 0 206 206",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.6523 188.869L85.8262 171.695L68.6523 154.521",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3047 171.695H85.8262",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8461 137.347C19.1981 107.864 24.8443 72.337 47.9112 48.8476C70.9781 25.3583 106.397 19.0682 136.141 33.1787C165.885 47.2893 183.419 78.6998 179.819 111.424C176.218 144.148 152.274 170.995 120.174 178.301",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M135.201 96.5596C135.201 93.0027 132.318 90.1194 128.761 90.1194H115.88V77.239C115.88 73.6822 112.997 70.7988 109.44 70.7988H96.5598C93.003 70.7988 90.1196 73.6822 90.1196 77.239V90.1194H77.2393C73.6824 90.1194 70.7991 93.0027 70.7991 96.5596V109.44C70.7991 112.997 73.6824 115.88 77.2393 115.88H90.1196V128.76C90.1196 132.317 93.003 135.201 96.5598 135.201H109.44C112.997 135.201 115.88 132.317 115.88 128.76V115.88H128.761C132.318 115.88 135.201 112.997 135.201 109.44V96.5596Z",
    stroke: "white",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareLineModal);
export default __webpack_public_path__ + "static/media/careLineModal.9c46ef16f7bc89cf0f64f9532b8e589c.svg";
export { ForwardRef as ReactComponent };